import { AppLayout } from '../../components/layouts/AppLayout'
import { ChartLine, HourglassHigh } from '@phosphor-icons/react'
import { typography, spacing } from '../../styles/design-system'

export default function ReportsPage() {
  return (
    <AppLayout>
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className={`${spacing.containerMaxWidth} ${spacing.containerPadding}`}>
          <div className="flex items-center justify-between h-16">
            <div>
              <h1 className={typography.pageTitle}>Relatórios e Análises</h1>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content - Empty State */}
      <main className={`${spacing.containerMaxWidth} ${spacing.containerPadding} py-6`}>
        <div className="flex flex-col items-center justify-center py-24 bg-white rounded-lg border border-gray-200">
          <div className="relative mb-6">
            <ChartLine size={64} className="text-gray-300" weight="duotone" />
            <div className="absolute -bottom-1 -right-1 bg-amber-100 rounded-full p-1">
              <HourglassHigh size={24} className="text-amber-600" weight="fill" />
            </div>
          </div>

          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Em Desenvolvimento
          </h2>
          <p className="text-gray-500 text-center max-w-md mb-6">
            O módulo de relatórios está sendo desenvolvido e estará disponível em breve.
            Você poderá gerar análises de custos, performance, rotas e muito mais.
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
              Análise de Custos
            </span>
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700">
              Performance de Embarques
            </span>
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-violet-50 text-violet-700">
              Rotas Mais Utilizadas
            </span>
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-orange-50 text-orange-700">
              Por Modalidade
            </span>
          </div>
        </div>
      </main>
    </AppLayout>
  )
}
